import { useTableHeaderRow } from '@react-aria/table';
import { TableState } from '@react-stately/table';
import { GridNode } from '@react-types/grid';
import { cx } from 'class-variance-authority';
import { forwardRef, useImperativeHandle, useRef } from 'react';

interface HeaderProps<T> {
    item: GridNode<T>;
    state: TableState<T>;
    children?: React.ReactNode;
    className?: string;
}

const HeaderRow = forwardRef<HTMLTableRowElement, HeaderProps<unknown>>(
    ({ children, item, className, state, ...props }, ref) => {
        const tableHeaderRowRef = useRef<HTMLTableRowElement | null>(null);
        const {
            rowProps
        }: {
            rowProps: React.HTMLAttributes<unknown>;
        } = useTableHeaderRow({ node: item }, state, tableHeaderRowRef);

        useImperativeHandle(ref, () => tableHeaderRowRef?.current);

        return (
            <tr className={cx('tw-overflow-visible', className)} ref={tableHeaderRowRef} {...rowProps} {...props}>
                {children}
            </tr>
        );
    }
);

HeaderRow.displayName = 'TableHeader';

export default HeaderRow;
